import { IBaseService, IPaginationDto } from '@/bundles/App/interfaces';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import HttpTransport from '@/bundles/Http/transport/HttpTransport';

export default class PhysicalExerciseService implements IBaseService<any> {
  errorMapper: ErrorMapper;
  transport: HttpTransport;

  constructor (props: IBaseService<any>) {
    this.errorMapper = props.errorMapper;
    this.transport = props.transport;
  }

  getList(params: IPaginationDto) {
    try {
      return this.transport.get('/physical-exercise/list', params);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  createExercise(formData: FormData) {
    try {
      return this.transport.post('/physical-exercise/create-with-thumbnail', formData, { 'content-type': 'multipart/form-data' });
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  updateExercise(id: number, formData: FormData) {
    try {
      return this.transport.put(`/physical-exercise/${id}`, formData, {'content-type': 'multipart/form-data'});
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }
}
